<div class='form-group'>
	<label *ngIf='label'>{{label}}</label>
	<label *ngIf='customLabel'><ng-content></ng-content></label>
	<textarea 
		class="form-control" 
		[disabled]="disabled"
		[(ngModel)]="inputValue" 
		(change)="updateFormInputValue()" 
		[name]="inputName"
		[ngModelOptions]="{ standalone: true }"
		[placeholder]="placeholder"
		[rows]="rows"></textarea>
	<app-form-help-text [helpText]="helpText"></app-form-help-text>
</div>